import { render, staticRenderFns } from "./SolutionsCarouselSliderMobile.vue?vue&type=template&id=9c115caa"
import script from "./SolutionsCarouselSliderMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./SolutionsCarouselSliderMobile.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SolutionsCarouselSlideMobile: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/components/sections/sliderSection/SolutionsCarouselSlideMobile.vue').default})
